import React from 'react';
import PropTypes from 'prop-types';

// HOC to defer some api calls to clientside
// componentDidMount is only called clientside, call dispatched actions there.
// for server side data, do that in preload.
// render-props pattern HOC https://reactjs.org/docs/render-props.html
function clientPreload(Component) {
  return class extends React.Component {
    static propTypes = {
      // Client Preloads should be an array of functions that return promises.
      clientPreloads: PropTypes.arrayOf(PropTypes.func),
    }

    static defaultProps = {
      clientPreloads: [],
    }

    // dispatch client side actions here
    componentDidMount() {
      // Map clientPreload functions to the promises they return
      Promise.all(this.props.clientPreloads.map(func => func()));
    }

    render() {
      return <Component {...this.props} />;
    }
  };
}

export default clientPreload;



// WEBPACK FOOTER //
// ./app/common/containers/client-preload.jsx